import React from 'react'
import formStyles from 'styles/form.module.scss'
import { Field } from 'react-final-form'
import {
  required,
  noSpaces,
  minValue,
  inputHasErr,
  characterLimit,
  composeValidators,
} from 'utils/validations'

const Password = () => {
  return (
    <Field
      name="password1"
      validate={composeValidators(
        required('password1'),
        minValue('password1', 4),
        characterLimit('Password', 20),
        noSpaces('password1')
      )}
    >
      {({ input, meta }) => (
        <div className={`form-group col-md-12 ${formStyles.formEleWrap}`}>
          <label className={formStyles.layerLable}>Create a password</label>
          <input
            data-testid="password1"
            className={`${inputHasErr(meta) &&
              formStyles.inputError} form-control ${
              formStyles.formTextFreeField
            }`}
            value={null}
            type="password"
            {...input}
          />
          {meta.touched && meta.error && (
            <p data-testid="password1_error" className={formStyles.error}>
              {meta.error}
            </p>
          )}
        </div>
      )}
    </Field>
  )
}

export default Password
